import { V2BaseClientSdk } from "./V2BaseClientSdk";

/**
 * 饭橘sdk
 */
export class V2FanjuClientSdk extends V2BaseClientSdk {
}